import clsx from 'clsx';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  shapeContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '1em',
  },
  shapeCircle: {
    backgroundColor: 'black',
    width: 15,
    height: 15,
    borderRadius: '50%',
  },
  redCircle: {
    backgroundColor: 'red',
  },
  greenCircle: {
    backgroundColor: 'green',
  },
}));

const StCell = ({ value }) => {
  const classes = useStyles();

  return (
    <div className={classes.shapeContainer}>
      <div className={clsx(classes.shapeCircle, value ? classes.greenCircle : classes.redCircle)} />
    </div>
  );
};

export default StCell;
